import { GENDER } from "@ehealth_tools/common-booking/src/data/booking.types";
import { ID } from "@ehealth_tools/common/src/data/propertyTypes/property.types";

export enum JOB_TYPE {
    /**
     * Developer profile
     */
    DEV = 1,
    /**
     * Coach
     */
    COACH = 2,
}

export enum USER_TYPE {
    UNDEFINED = 0,
    PATIENT = 1,
    /**
     * Worker in a caregiving structure : nurse, doctor etc...
     */
    CAREGIVER = 2,
    COACH = 3
}


export enum REGISTRATION_STATUS {
    /**
     * Validated
     */
    VALIDATED = "validated",
    /**
     * Waiting
     */
    PENDING = "pending",
    /**
     * Rejected
     */
    REJECTED = "rejected"
}

/**
 * Numerical enum for the days of the week, ranging from 1 (Monday) to 7 (Sunday)
 */
export enum DAYS_OF_WEEK {
    MONDAY = 1,
    TUESDAY = 2,
    WEDNESDAY = 3,
    THURSDAY = 4,
    FRIDAY = 5,
    SATURDAY = 6,
    SUNDAY = 7,
}

/** List of DAYS_OF_WEEK enum values */
export type DAYS_OF_WEEKS = DAYS_OF_WEEK[];

export enum COMPANY_POSITION {
    MANAGER = "manager",
    EMPLOYEE = "employee",
    CUSTOMER = "customer",
    ARCHIVED = "archived"
}

export enum COMPANY_STATUS {
    /** Company is fully active and can use all actions available */
    ACTIVE = 1,
    /** Company is in a pending state, and can take only a restricted set of actions */
    PENDING = 2,
    /** Company is blocked and cannot take any actions */
    BLOCKED = 3
}

/** Type for id array, that is not associated with JSON field marshaller */
export type IDS = ID[];

export type UserFieldTypes = {
    "COACH_TYPE": JOB_TYPE,
    "GENDER": GENDER,
    "USER_TYPE": USER_TYPE,
    "REGISTRATION_STATUS": REGISTRATION_STATUS,
    "DAYS_OF_WEEKS": DAYS_OF_WEEKS,
    "COMPANY_POSITION": COMPANY_POSITION,
    "IDS": IDS
}

// FieldTypeNames are used in SQL table definitions in order to define which marshallers should be used to marshal / unmarshal object from / to DB
export type UserFieldTypeName = keyof UserFieldTypes;